module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-not-found"
  }, [_c('h1', [_vm._v("Oops! That category doesn't exist.")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.linkToCategoryIndex
    }
  }, [_vm._v("\n        Back to the category index\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f40e959e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/forum/category-not-found.vue
// module id = 2146
// module chunks = 2